// MOCK DATA - placeholder brand, copy and contact details (replace with real content later)
export const brand = {
  name: "PIEDMONT",
  legal: "Piedmont Construction Co., Inc.",
  est: "EST. 2008 \u2022 CENTRAL VIRGINIA",
  phone: "804.915.1439",
  phoneHref: "tel:8049151439",
  email: "info@piedmontconstruct.com",
  address1: "2070 Valpark Drive",
  address2: "Oilville, VA 23129",
};

export const navLinks = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Sectors", id: "sectors" },
  { label: "Projects", id: "projects" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

export const heroImage =
  "https://images.unsplash.com/photo-1758399750112-366c3c804eb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const heroStats = [
  { value: 248, label: "Projects Completed" },
  { value: 92, label: "Happy Clients" },
  { value: 16, label: "Years Experience" },
];

export const currentProject = {
  title: "Riverside Civic Hall Renovation",
  progress: 73,
  due: "OCT 2026",
};

export const services = [
  {
    icon: "ClipboardList",
    title: "Preconstruction Services",
    text: "Budgeting, scheduling, feasibility and value engineering handled before the first shovel hits the ground.",
    phase: "Phase 01",
    details: ["Cost estimating", "Site analysis", "Value engineering", "Permitting support"],
  },
  {
    icon: "HardHat",
    title: "Construction Management",
    text: "Hands-on coordination of trades, budgets and timelines so every milestone lands where it should.",
    phase: "Phase 02",
    details: ["Schedule control", "Trade coordination", "Budget tracking", "Safety programs"],
  },
  {
    icon: "Building2",
    title: "General Construction",
    text: "Ground-up builds for commercial, residential and institutional clients, delivered with care at every stage.",
    phase: "Phase 03",
    details: ["Foundations", "Structural framing", "MEP systems", "Interior finishes"],
  },
  {
    icon: "Wrench",
    title: "Maintenance & Renovation",
    text: "Upgrades, remodels and long-term facility care that keep buildings performing for decades.",
    phase: "Phase 04",
    details: ["Remodeling", "System upgrades", "Historic restoration", "Facility care"],
  },
];

export const sectors = [
  { icon: "GraduationCap", title: "Education" },
  { icon: "Hotel", title: "Hospitality" },
  { icon: "Store", title: "Commercial Developments" },
  { icon: "Briefcase", title: "Offices" },
  { icon: "Factory", title: "Industrial" },
  { icon: "Hospital", title: "Healthcare" },
  { icon: "Trophy", title: "Sports & Recreational Venues" },
  { icon: "Home", title: "Residential Developments" },
  { icon: "Zap", title: "Energy Infrastructure" },
];

export const projects = [
  {
    id: 1,
    title: "The Overlook Residence",
    category: "Residential",
    location: "Goochland County, VA",
    year: 2025,
    image: "https://images.unsplash.com/photo-1722421492323-eaf9c401befe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description: "A three-level stone and timber home designed around long valley views, with a fully custom interior package.",
    size: "6,400 sq ft",
  },
  {
    id: 2,
    title: "Meridian Office Tower",
    category: "Commercial",
    location: "Richmond, VA",
    year: 2024,
    image: "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description: "Twelve floors of Class-A office space with a high-performance curtain wall and rooftop terrace.",
    size: "180,000 sq ft",
  },
  {
    id: 3,
    title: "Foundry Loft Conversion",
    category: "Renovation",
    location: "Shockoe Bottom, Richmond",
    year: 2024,
    image: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description: "Adaptive reuse of a former warehouse into 38 loft residences while preserving original brick and steel.",
    size: "52,000 sq ft",
  },
  {
    id: 4,
    title: "Hillcrest Estate",
    category: "Residential",
    location: "Albemarle County, VA",
    year: 2023,
    image: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description: "A contemporary estate with layered terraces, floor-to-ceiling glazing and a detached guest house.",
    size: "8,900 sq ft",
  },
  {
    id: 5,
    title: "Harbor Point Plaza",
    category: "Commercial",
    location: "Norfolk, VA",
    year: 2023,
    image: "https://images.unsplash.com/photo-1618439569122-eddffc5104b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description: "Mixed-use retail and office complex anchored by a public plaza and structured parking.",
    size: "240,000 sq ft",
  },
  {
    id: 6,
    title: "Northside Logistics Hub",
    category: "Industrial",
    location: "Ashland, VA",
    year: 2022,
    image: "https://images.unsplash.com/photo-1709934645644-f055bb2b75de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description: "Tilt-up distribution facility with 40' clear heights and 60 dock doors, delivered two weeks early.",
    size: "410,000 sq ft",
  },
];

export const included = [
  { icon: "ClipboardCheck", title: "Detailed Planning", text: "A clear roadmap with milestones and expectations agreed on before work begins." },
  { icon: "ShieldCheck", title: "Quality Assurance", text: "Inspections at every stage so the finished build meets the standard we promised." },
  { icon: "PhoneCall", title: "Dedicated Manager", text: "One point of contact who knows your project inside and out, start to finish." },
  { icon: "Wrench", title: "2-Year Warranty", text: "Workmanship coverage and responsive aftercare long after the keys are handed over." },
];

export const about = {
  image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  text: "We started with a small crew and a straightforward belief: build honestly, communicate openly, and treat every client's vision as if it were our own.",
  stats: [
    { value: 200, label: "Team Members" },
    { value: 16, label: "Years in Business" },
  ],
  award: "2024 Regional Builder of the Year",
  values: [
    { icon: "Handshake", color: "text-yellow-400", title: "Transparency", text: "Open books and honest updates, so there are never surprises on your invoice." },
    { icon: "Leaf", color: "text-emerald-400", title: "Sustainability", text: "Responsible materials and methods that reduce waste and respect the land." },
  ],
};

export const testimonials = [
  {
    quote: "They took a rough sketch and turned it into the building we'd imagined for years. Every detail was handled with care.",
    name: "Jordan Ellis",
    role: "Director \u2022 Example Properties \u2022 Richmond, VA",
    initials: "JE",
  },
  {
    quote: "On time, on budget, and the most communicative team we've ever worked with. We've already booked our next project.",
    name: "Priya Raman",
    role: "COO \u2022 Sample Health Group \u2022 Norfolk, VA",
    initials: "PR",
  },
  {
    quote: "Our renovation was complicated and historic. The crew respected the building and delivered something remarkable.",
    name: "Marcus Webb",
    role: "Owner \u2022 Foundry Lofts \u2022 Richmond, VA",
    initials: "MW",
  },
];

export const projectTypes = ["Residential Home", "Commercial Space", "Renovation", "Other"];

// ---- Project detail pages (MOCK) ----
const u = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400`;
const progressPool = [
  u("photo-1698889670684-0f4a7aa7cba8"),
  u("photo-1718816281270-ed6ef8357859"),
  u("photo-1718816281207-3b253cff549a"),
  u("photo-1698889670677-caac664cfce0"),
];
const finishPool = [
  u("photo-1724582586529-62622e50c0b3"),
  u("photo-1704040686413-2c607dbd2f06"),
  u("photo-1724582586495-d050726cf354"),
  u("photo-1646987916641-1f3c8992daa2"),
];

const details = {
  1: { client: "Private Homeowner", duration: "14 months", value: "$3.2M", scope: ["Custom stone cladding", "Timber-frame great room", "Geothermal HVAC", "Infinity-edge terrace"] },
  2: { client: "Example Realty Partners", duration: "26 months", value: "$64M", scope: ["Unitized curtain wall", "Post-tensioned slabs", "LEED Gold systems", "Rooftop amenity deck"] },
  3: { client: "Foundry Lofts LLC", duration: "18 months", value: "$21M", scope: ["Historic tax credit compliance", "Structural steel retrofit", "38 loft residences", "Preserved heavy-timber details"] },
  4: { client: "Private Family Trust", duration: "16 months", value: "$4.7M", scope: ["Cantilevered terraces", "Floor-to-ceiling glazing", "Detached guest house", "Smart-home integration"] },
  5: { client: "Sample Harbor Group", duration: "30 months", value: "$88M", scope: ["Retail podium", "Six-level parking deck", "Public plaza & fountains", "Office tower shell"] },
  6: { client: "Example Logistics Co.", duration: "11 months", value: "$37M", scope: ["Tilt-up concrete panels", "60 dock doors", "ESFR sprinkler system", "Trailer yard & paving"] },
};

const phaseTemplate = [
  { title: "Preconstruction & Design", text: "Budget alignment, value engineering, permitting and a detailed master schedule." },
  { title: "Site Work & Foundations", text: "Clearing, grading, utilities and foundations poured and inspected." },
  { title: "Structure & Framing", text: "Primary structure erected and topped out, with the envelope sealed against weather." },
  { title: "MEP & Interiors", text: "Mechanical, electrical and plumbing rough-ins followed by drywall and finishes." },
  { title: "Final Inspection & Handover", text: "Punch-list complete, certificates issued and keys handed to the client." },
];
const months = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];

projects.forEach((p, i) => {
  const d = details[p.id];
  const rot = (arr, n) => arr.slice(n).concat(arr.slice(0, n));
  p.slug = p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  Object.assign(p, d);
  p.gallery = [
    { src: p.image.replace("w=1200", "w=1600"), caption: "Completed exterior" },
    ...rot(progressPool, i % 4).slice(0, 2).map((src, k) => ({ src, caption: k === 0 ? "Structure in progress" : "Interior rough-in" })),
    ...rot(finishPool, i % 4).slice(0, 3).map((src, k) => ({ src, caption: ["Finished interior", "Living spaces", "Final details"][k] })),
  ];
  // spread phases back from completion year
  const start = p.year * 12 + 10 - parseInt(d.duration, 10);
  const total = parseInt(d.duration, 10);
  const weights = [0.1, 0.18, 0.3, 0.3, 0.12];
  let acc = start;
  p.timeline = phaseTemplate.map((ph, k) => {
    const at = Math.round(acc);
    acc += total * weights[k];
    return { ...ph, date: `${months[((at % 12) + 12) % 12]} ${Math.floor(at / 12)}` };
  });
});

// ---- Before/After + per-project client quotes (MOCK) ----
const projectQuotes = {
  1: { quote: "Every morning I look out at that valley and remember how carefully they placed each window. It's exactly the home we pictured.", name: "Dana Whitfield", role: "Homeowner", initials: "DW" },
  2: { quote: "A complex tower on a tight urban lot, and they never once lost control of the schedule. Our tenants moved in on day one.", name: "Rafael Ortiz", role: "Managing Partner, Example Realty", initials: "RO" },
  3: { quote: "They treated a hundred-year-old warehouse with real respect. The original brick and beams are now the heart of every loft.", name: "Marcus Webb", role: "Owner, Foundry Lofts", initials: "MW" },
  4: { quote: "Weekly walkthroughs, honest pricing and zero surprises. Building a house this ambitious felt surprisingly calm.", name: "Elena Hart", role: "Family Trustee", initials: "EH" },
  5: { quote: "Coordinating retail, parking and office in one phase is hard. They made it look routine and handed over a plaza the city loves.", name: "Kendra Mills", role: "Development Director, Sample Harbor", initials: "KM" },
  6: { quote: "Delivered two weeks early with every dock door operational. That head start was worth a full quarter of revenue to us.", name: "Tom Becker", role: "VP Operations, Example Logistics", initials: "TB" },
};
const beforePool = [progressPool[1], progressPool[3], progressPool[0], progressPool[2]];
projects.forEach((p, i) => {
  p.testimonial = projectQuotes[p.id];
  p.beforeAfter = {
    before: beforePool[i % 4],
    after: finishPool[i % 4],
    beforeLabel: "During Construction",
    afterLabel: "Completed",
  };
});
